module.exports = __webpack_public_path__ + "ceea4414df3ed26541b69d8b0aad4d2c.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/corporateacon-reg-webfont.svg
// module id = 301
// module chunks = 0 1